export const classNames = (...parts) => parts.filter(Boolean).join(' ');

export const formatBytes = (bytes) => {
  if (!bytes || Number.isNaN(Number(bytes))) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  let size = Number(bytes);
  let idx = 0;
  while (size >= 1024 && idx < units.length - 1) {
    size /= 1024;
    idx += 1;
  }
  return `${size % 1 === 0 ? size : size.toFixed(1)} ${units[idx]}`;
};

export const formatDate = (value) => {
  if (!value) return '—';
  try {
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return value;
    return d.toLocaleString();
  } catch (e) {
    return value;
  }
};

export const visibilityLabel = (attachment) => (attachment?.is_private ? 'Private' : 'Public');

export const visibilityBadgeClass = (attachment) => (attachment?.is_private
  ? 'bg-red-100 text-red-700'
  : 'bg-green-100 text-green-700');

const sanitizeUrl = (url) => (url ? url.replace(/\s/g, '%20') : null);

const getFilename = (attachment) => (attachment?.title || attachment?.file_name || '').toLowerCase();

const extensionMatches = (filename, pattern) => {
  if (!filename) return false;
  return pattern.test(filename);
};

export const getAttachmentMediaType = (attachment) => {
  const mime = (attachment?.mime_type || '').toLowerCase();
  const filename = getFilename(attachment);

  if (mime.startsWith('image/') || extensionMatches(filename, /\.(png|jpe?g|gif|bmp|webp|svg)$/i)) {
    return 'image';
  }
  if (mime.startsWith('video/') || extensionMatches(filename, /\.(mp4|mov|webm|mkv|avi)$/i)) {
    return 'video';
  }
  if (mime.startsWith('audio/') || extensionMatches(filename, /\.(mp3|wav|aac|ogg|m4a)$/i)) {
    return 'audio';
  }
  return 'file';
};

const candidateLinks = (attachment) => (
  [
    attachment?.links?.cached,
    attachment?.links?.direct,
    attachment?.links?.preview,
    attachment?.links?.thumbnail,
    attachment?.links?.download,
    attachment?.preview?.thumbnail,
    attachment?.url,
  ].filter(Boolean)
);

export const getAttachmentPreviewUrl = (attachment) => sanitizeUrl(candidateLinks(attachment)[0] || null);

export const getAttachmentMediaUrl = (attachment) => {
  const links = [
    attachment?.links?.direct,
    attachment?.links?.stream,
    attachment?.links?.cached,
    attachment?.links?.download,
    attachment?.links?.preview,
    attachment?.links?.thumbnail,
    attachment?.preview?.thumbnail,
    attachment?.url,
  ].filter(Boolean);
  return sanitizeUrl(links[0] || null);
};

export const getAttachmentVideoMimeType = (attachment) => {
  const mime = (attachment?.mime_type || '').toLowerCase();
  if (mime === 'video/quicktime') {
    return 'video/mp4';
  }
  if (mime) {
    return mime;
  }

  const filename = getFilename(attachment);
  if (filename.endsWith('.mov') || filename.endsWith('.qt')) {
    return 'video/mp4';
  }
  if (filename.endsWith('.webm')) {
    return 'video/webm';
  }
  if (filename.endsWith('.ogv') || filename.endsWith('.ogg')) {
    return 'video/ogg';
  }
  return undefined;
};
